import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { invoiceTransactionCommand } from '../../command/transaction-invoice';
import { InvoiceTransactionService } from '../data/invoice-transaction.service';

@Injectable()
export class InvoiceTransactionsExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: InvoiceTransactionService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === invoiceTransactionCommand.export && command.itemsSource.length > 0;
    }
    return false;
  }
  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.export(command.items.map(item => item.id)).pipe(map(file => this._nativeWindow.save(file)));
    }
  }
}
